<template>
  <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always fetched from API) -->
  <div v-if="isHtmlContent" :key="`marketing-content-html-${order}`" :style="{ order: order }" v-html="htmlContent" />
  <div v-else-if="isImageContent" :key="`marketing-content-image-${order}`" :style="{ order: order }">
    <b-img-lazy
      :alt="imageContentAlternativeText"
      :class="imageDisplayClass"
      :src="getImage(imageContent.original)"
      class="img-fluid w-100 mb-3 mx-auto"
    />
  </div>
  <div v-else-if="isProductCarouselContent" :key="`marketing-content-product-carousel-${order}`" :style="{ order: order }">
    <ProductCarousel
      :key="productCarouselContent.productGroup.id"
      :action-link-text="productCarouselContent.linkName"
      :group="productCarouselContent.productGroup"
      :is-click-to-action-item="true"
      :redirect-path="redirectPath"
      class="mx-auto product-carousel-container"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import getImage from '@/mixins/getImage';
import ProductCarousel from '@/views/ProductCarousel';

export default {
  name: 'MarketingContent',
  components: {
    ProductCarousel,
  },
  mixins: [getImage],
  props: {
    contentType: {
      type: String,
      required: true,
    },
    content: {
      type: Object,
      required: false,
      default: null,
    },
    image: {
      type: Object,
      required: false,
      default: null,
    },
    html: {
      type: Object,
      required: false,
      default: null,
    },
    productCarousel: {
      type: Object,
      required: false,
      default: null,
    },
    order: {
      type: Number,
      required: false,
      default: 0,
    },
    redirectPath: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    isImageContent() {
      return this.contentType === 'Image';
    },
    isHtmlContent() {
      return this.contentType === 'Html';
    },
    isProductCarouselContent() {
      return this.contentType === 'Carousel';
    },
    htmlContent() {
      return this.html || this.content?.html;
    },
    productCarouselContent() {
      return (
        this.productCarousel || {
          productGroup: this.content?.productGroup,
          linkName: this.content?.linkName,
        }
      );
    },
    imageDisplayClass() {
      let size = '';

      switch (this.content?.resolution?.toUpperCase()) {
        case 'MOBILE':
          size = 'sm';
          break;
        case 'TABLET':
          size = 'md';
          break;
        case 'DESKTOP':
          size = 'lg';
          break;
      }

      return size ? `d-${size}-block-only` : '';
    },
    imageContentAlternativeText() {
      return this.content?.alternativeText || '';
    },
    imageContent() {
      return this.image || this.content?.image;
    },
  },
};
</script>

<style lang="scss">
@import '@docupet/component-library/src/assets/styles/_mixins';

.d-sm-block-only,
.d-md-block-only,
.d-lg-block-only {
  display: none !important;
}

.d-sm-block-only {
  @include media-breakpoint-between(xs, sm) {
    display: block !important;
  }
}

.d-md-block-only {
  @include media-breakpoint-only(md) {
    display: block !important;
  }
}

.d-lg-block-only {
  @include media-breakpoint-up(lg) {
    display: block !important;
  }
}

// Utility Styles for HTML Content
.rounded-12-5 {
  border-radius: 12.5px;
}

.rounded-lg-12-5 {
  @include media-breakpoint-up(lg) {
    border-radius: 12.5px;
  }
}
</style>

<style lang="scss" scoped>
.product-carousel-container {
  max-width: 1024px;
  display: contents;
  flex-direction: column;
  width: available;
  width: -moz-available;
  width: -webkit-fill-available;
}

// Product Styles
div:has(> .product-group-style-action-link) {
  margin-left: 25px;
  margin-right: 25px;
}

.product-group-style-action-link {
  padding-top: 4px;
  padding-bottom: 4px;
  margin-bottom: 16px;
  border-radius: 15px;
}
</style>
